import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import _ from 'lodash';

import {
    IButtonStyles,
    DefaultButton,
    Label,
    PrimaryButton,
    Stack,
    TooltipHost
} from '@fluentui/react';

import { TicketAttachmentFile } from '../../../../../api-client';
import { DataEnchanter } from '../../../../../utils/data-enchanters';
import { useTicketViewAttachment } from './hooks/useTicketViewAttachment';

import { IAIShimmer } from '../../../../../common/components/IAIShimmer';

interface ITicketViewAttachment {
    disabled?: boolean;
    ticketId?: string;
}

const TicketViewAttachment: React.FunctionComponent<ITicketViewAttachment> = ({ disabled, ticketId }) => {
    const {
        handleRetrieveTicketAttachments,
        ticketAttachments,
        ticketAttachmentsLoading,
        handleRetrieveTicketAttachment,
        ticketAttachmentLoading,
        handleUploadTicketAttachment,
        uploadTicketAttachmentLoading
    } = useTicketViewAttachment();

    useEffect(() => {
        ticketId && handleRetrieveTicketAttachments({ id: ticketId });
    }, [ticketId]);

    const buttonStyles: IButtonStyles = {
        root: {
            minWidth: 0,
            padding: '0 5px'
        }
    }

    // Upload Attachments

    const [attachmentsUpload, setAttachmentsUpload] = useState<any[]>([]);

    useEffect(() => {
        if (attachmentsUpload && !!attachmentsUpload.length) {
            _.each(attachmentsUpload, entry => {
                if (entry) {
                    DataEnchanter.fileToB64(entry).then((response) => {
                        let attachmentFile: TicketAttachmentFile = {
                            fileContent: response.split(',')[1],
                            fileName: entry.name,
                            fileSize: entry.size,
                            fileType: entry.type
                        };

                        if (ticketId) {
                            handleUploadTicketAttachment({
                                id: ticketId,
                                attachment: attachmentFile,
                                onSuccess: () => handleRetrieveTicketAttachments({ id: ticketId })
                            });
                        }
                    });
                }
            });
        }
    }, [attachmentsUpload]);

    const _handleDrop = useCallback((acceptedFiles) => {
        setAttachmentsUpload(acceptedFiles);
    }, []);

    const {
        getRootProps,
        getInputProps
    } = useDropzone({ onDrop: _handleDrop });

    return (
        <div className={`ticket-attachment-container`}>
            <Label>
                Allegati:
            </Label>

            <IAIShimmer type={'shimmer-heading'} loading={ticketAttachmentsLoading}>
                <Stack horizontal tokens={{ childrenGap: 15 }}>
                    {ticketId &&
                        _.map(ticketAttachments, (dataItem, dataIndex) => (
                            <TooltipHost
                                key={dataIndex}
                                content={`${dataItem.fileName} (${DataEnchanter.fileSize(dataItem.fileSize)})`}
                            >
                                <DefaultButton
                                    id={'attachment_button_' + dataIndex}
                                    iconProps={{ iconName: DataEnchanter.fileIcon(dataItem.fileName || '') }}
                                    styles={buttonStyles}
                                    onClick={() => {
                                        handleRetrieveTicketAttachment({
                                            id: ticketId,
                                            attachmentId: dataItem.id || '',
                                            fileName: dataItem.fileName || ''
                                        });
                                    }}
                                />
                            </TooltipHost>
                        ))
                    }

                    <div {...getRootProps({ className: 'dropzone' })}>
                        <input
                            {...getInputProps()}
                            disabled={disabled || ticketAttachmentLoading || uploadTicketAttachmentLoading}
                        />

                        <PrimaryButton
                            disabled={disabled || ticketAttachmentLoading || uploadTicketAttachmentLoading}
                            iconProps={{ iconName: 'Add' }}
                            styles={buttonStyles}
                        />
                    </div>
                </Stack>
            </IAIShimmer>
        </div>
    );
}

export default TicketViewAttachment;